import { render, staticRenderFns } from "./DateMasksButton.vue?vue&type=template&id=47b20f26"
import script from "./DateMasksButton.vue?vue&type=script&lang=js"
export * from "./DateMasksButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports